import { KeyValueModel } from "model";


export const temasMock: KeyValueModel[] = [
    new KeyValueModel(0, "Light (Claro)"),
    new KeyValueModel(1, "Dark (Escuro)")
]